import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTransactions } from 'store/transactions/useTransactions';
import { ITransferAludelForm } from 'components/onboarding/deployment/type';
import { transferAludelSchema } from 'components/onboarding/deployment/formSchema';
import { FormError } from 'components/onboarding/form/FormError';
import {
  Heading,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text
} from '@chakra-ui/react';
import { FC } from 'react';
import { ethers } from 'ethers';

type Props = {
  aludelAbi: ethers.ContractInterface;
};

export const TransferAludelForm: FC<Props> = ({ aludelAbi }) => {
  const { transferProgramOwnership } = useTransactions();
  const { rewardProgramAddress } =
    useParams<{ rewardProgramAddress: string }>();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ITransferAludelForm>({
    resolver: yupResolver(transferAludelSchema),
    mode: 'onBlur',
    defaultValues: {
      address: ''
    }
  });

  const transferAludel = async ({ address }: { address: string }) => {
    await transferProgramOwnership(
      rewardProgramAddress,
      address,
      rewardProgramAddress,
      aludelAbi
    );
  };

  return (
    <>
      <Heading size='md' mb={6}>
        Transfer Aludel Ownership
      </Heading>
      <Text color='gray.200' mb={6}>
        This option transfers the ownership of this reward program contact to
        another wallet. This does not transfer the PowerSwitch owner, which has
        the ability to shutdown the program.
      </Text>
      <Stack
        direction={['column', 'row']}
        alignItems={['flex-start', 'flex-end']}
        spacing={4}
      >
        <FormControl width='max-content' isRequired>
          <FormLabel>Enter Address</FormLabel>
          <Input
            id='address'
            type='text'
            borderColor={'gray.300'}
            placeholder='0x'
            {...register('address')}
          />
          {errors.address && <FormError>{errors.address.message}</FormError>}
        </FormControl>
        <Button
          px={6}
          type='submit'
          borderRadius={'lg'}
          onClick={handleSubmit((d) => transferAludel(d))}
        >
          Transfer Aludel
        </Button>
      </Stack>
    </>
  );
};
